import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

export const renderSelectField = ({
  input,
  label,
  meta: { touched, error, warning },
  children,
  defaultValue,
  onChange,
}) => {
  const getValue = (value) => {
    if (value === 'true') {
      return true
    }
    if (value === 'false') {
      return false
    }
    return value
  }
  return (
      <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
        <ReactBootstrap.Form.Label>{label}</ReactBootstrap.Form.Label>
        <select
            onChange={onChange}
            placeholder={label}
            defaultValue={getValue(defaultValue)}
            {...input}
            className="form-control"
        >
          {children}
        </select>
        {touched &&
            ((error && <span className="text-danger">{error}</span>) ||
                (warning && <span className="text-warning">{warning}</span>))}
      </ReactBootstrap.Form.Group>
  )
}

export const renderSelectField2 = (props) => {
    console.log(props)
   const {
  input,
  label,
  meta: { touched, error, warning },
  value,
  onChange,
  options
} = props
    return (
      <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
        <ReactBootstrap.Form.Label>{label}</ReactBootstrap.Form.Label>
        <select
            onChange={onChange}
            placeholder={label}
            {...input}
            value={input.value}
            className="form-control"
        >
            {options && options.map((c) => {
                return (
                  <option selected={c.value==input.value} key={c.value} value={c.value}>
                    {c.text}
                  </option>
                )
              })}
        </select>
        {touched &&
            ((error && <span className="text-danger">{error}</span>) ||
                (warning && <span className="text-warning">{warning}</span>))}
      </ReactBootstrap.Form.Group>
  )
}

export const renderSelectFieldInline = (props) => {
    console.log(props)
   const {
  input,
  label,
  meta: { touched, error, warning },
  value,
  onChange,
  options
} = props
    return (
      <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
           <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12} md={3}>
        <ReactBootstrap.Form.Label>{label}</ReactBootstrap.Form.Label>
        </ReactBootstrap.Col>
                  <ReactBootstrap.Col xs={12} md={9}>
        <select
            onChange={onChange}
            placeholder={label}
            {...input}
            value={input.value}
            className="form-control"
        >
            {options && options.map((c) => {
                return (
                  <option selected={c.value==input.value} key={c.value} value={c.value}>
                    {c.text}
                  </option>
                )
              })}
        </select>
                  </ReactBootstrap.Col>
               </ReactBootstrap.Row>
       <ReactBootstrap.Row>
     <ReactBootstrap.Col xs={12}>
        {touched &&
            ((error && <span className="text-danger">{error}</span>) ||
                (warning && <span className="text-warning">{warning}</span>))}
     </ReactBootstrap.Col>
       </ReactBootstrap.Row>
      </ReactBootstrap.Form.Group>
  )
}
